import React from 'react';
interface LogoProps {
  variant?: string;
  className?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
}
export function Logo({
  className = '',
  width,
  height,
  alt = 'Snakker logo'
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/tRUC2wJNjE4EriFcjz3TyS/snakker_logo_new2.png" alt={alt} width={width} height={height} className={`object-contain ${className}`} style={{
    width,
    height
  }} data-id="element-44" data-mp="3qbeaelr8a0y2" />;
}